import axios, { CancelTokenSource } from 'axios';
import { useRouter } from 'next/router';

interface IUploadRequestsSource {
    cancelTokenSourceKey?: CancelTokenSource;
    cancel(cancelTokenSourceKey: string): void;
}

const UploadRequestsSource: IUploadRequestsSource = {
    cancel: (cancelTokenSourceKey) => {
        if (UploadRequestsSource?.[cancelTokenSourceKey]) {
            UploadRequestsSource[cancelTokenSourceKey].cancel('fileUpload_cancelled');
            delete UploadRequestsSource[cancelTokenSourceKey];
            return;
        }
        console.warn(
            'UploadRequestsSource: cannot abort upload request corresponding to cancelTokenSourceKey:',
            cancelTokenSourceKey
        );
    }
};

export default function useUploadRequestAbort(): IUploadRequestsSource {
    const { asPath } = useRouter();

    if (UploadRequestsSource && !UploadRequestsSource?.[asPath]) {
        UploadRequestsSource[asPath] = axios.CancelToken.source();
    }

    return UploadRequestsSource;
}
